import folderIdFactory from 'owa-service/lib/factory/folderId';
import getCalendarSharingPermissionsOperation from 'owa-service/lib/operation/getCalendarSharingPermissionsOperation';
import getCalendarSharingPermissionsRequest from 'owa-service/lib/factory/getCalendarSharingPermissionsRequest';
import GetCalendarSharingPermissionsResponse from 'owa-service/lib/contract/GetCalendarSharingPermissionsResponse';

/**
 * Makes the getCalendarSharingPermissions call to the server to get calendar sharing permissions for a given calendar
 * @param {string} folderId folder id of requested calendar
 * @returns promise with list of recipients with whom calendar have been shared along with their permissions
 */
export default function getPublishingPermissionsService(
    folderId: string
): Promise<GetCalendarSharingPermissionsResponse> {
    return getCalendarSharingPermissionsOperation({
        request: getCalendarSharingPermissionsRequest({
            CalendarId: folderIdFactory({ Id: folderId }),
        }),
    })
        .then(response => {
            if (response && response.WasSuccessful) {
                return response;
            } else {
                return null;
            }
        })
        .catch(error => {
            return Promise.resolve(null);
        });
}
